
import {Component, Vue} from "vue-property-decorator";
import FormWrapper from "@/components/FormWrapper.vue";
import BankaPicker from "@/components/pickers/BankaPicker.vue";
import ParaBirimiPicker from "@/components/pickers/ParaBirimiPicker.vue";
import IbanNumarasi from "@/components/inputs/IbanNumarasi.vue";
import BankaHesabiTipiPicker from "@/components/pickers/BankaHesabiTipiPicker.vue";
import {BankaHesabiTipi} from "@/enum/BankaHesabiTipi";
import {PersonelEntity} from "@/entity/PersonelEntity";
import {BankaHesabiEntity} from "@/entity/BankaHesabiEntity";
import {XmlBankaHesabiEntity} from "@/entity/XmlBankaHesabiEntity";

@Component({
  components: {
    FormWrapper,
    BankaPicker,
    ParaBirimiPicker,
    IbanNumarasi,
    BankaHesabiTipiPicker,
  },
})
export default class XmlHesapEkle extends Vue {
  localValue: XmlBankaHesabiEntity = new XmlBankaHesabiEntity();
  hesapTipiEnum = BankaHesabiTipi;
  avukatlar: Array<PersonelEntity> = [];
  muvekkiller: Array<any> = [];


  mounted() {
    this.localValue.hesap_tipi = this.hesapTipiEnum.iban;
    this.loadAvukatlar();
    this.loadMuvekkiller();
  }

  loadAvukatlar() {
    this.$http.get("/api/v1/personel/filter?type=avukat").then((response) => {
      this.avukatlar = response.data;
    });
  }

  loadMuvekkiller() {
    this.$http.get("/api/v1/tahsilat-muvekkil-list/").then((response: any) => {
      this.muvekkiller = response;
    });
  }

  getMuvekkilAd(item: any): string {
    if (item.ad && item.soyad) {
      return item.ad + ' ' + item.soyad;
    } else if (item.sirket_adi) {
      return item.sirket_adi;
    }
    return '';
  }

  saveBankaHesabi() {
    let url: string | null = null;

    // Check if avukat is selected
    if (this.localValue.avukat_id) {
      url = 'personel/' + this.localValue.avukat_id;
    }
    // Check if müvekkil is selected
    else if (this.localValue.muvekkil) {
      if (this.localValue.muvekkil.sirket_adi) {
        // Kurum
        url = 'kurum/' + this.localValue.muvekkil.kurum_id;
      } else if (this.localValue.muvekkil.id) {
        // Kisi
        url = 'kisi/' + this.localValue.muvekkil.id;
      }
    }

    if (!url) {
      return Promise.reject('Avukat veya müvekkil seçilmedi');
    }

    return this.$http.post('/api/v1/' + url + '/banka-hesabi', this.localValue).finally(() => {
      this.$emit("load");
      this.$emit("onSuccess");
    });
  }

  onSuccess() {
    this.$emit("onSuccess");
    this.$emit("load");
  }

  onClose() {
    this.$emit("onClose");
  }

  /*input() {
    this.$emit("input", this.localValue);
    this.$forceUpdate();
  }*/
}
